import CenteredForm from "../../components/forms/centered_form/CenteredForm";
import OauthIcons from "../../components/forms/oauth_icons/OauthIcons";
import { UserContext } from "../../contexts/UserContext";
import { Form, Button, Spinner } from 'react-bootstrap';
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLogin } from "../../api/query_hooks";
import Divider from "../../components/layout/divider/Divider";

const Login = () => {

    const { user } = useContext(UserContext);
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const mutation = useLogin();

    const handleLogin = async (e) => {
        e.preventDefault();

        mutation.mutate({username, password});
    };

    useEffect(() => {   // redirecting if the user is already logged in at page load
        if(user.isLogged) navigate('/account');
    }, []);


    return (
        <CenteredForm onSubmit={handleLogin}>

            <div className="d-flex flex-column justify-content-center align-items-center col-12">
                <h1 className="mb-4">Log in</h1>
            </div>

            <Form.Group className="mb-3 col-10 col-lg-8" controlId="usernameBox" >
                <Form.Label className="text-white-50">username</Form.Label>
                <Form.Control className="bg-darker bg-dark" type="text" placeholder="username/email" onChange={e => setUsername(e.target.value)} aria-describedby="username" />
            </Form.Group>

            <Form.Group className="mb-3 col-10 col-lg-8" controlId="passwordBox" >
                <Form.Label className="text-white-50">password</Form.Label>
                <Form.Control className="bg-darker bg-dark" type="password" placeholder="password" onChange={e => setPassword(e.target.value)} aria-describedby="password" />
                <Form.Text className="text-light" muted>
                    <Link className="link-secondary" to={'/password-forgotten'}>Forgot your password?</Link>
                </Form.Text>
            </Form.Group>

            <Button variant="warning" className="mb-2 px-4 px-lg-3" type="submit" aria-describedby="log in" disabled={mutation.isFetching}>
                {mutation.isFetching && <Spinner size="sm" animation="border" role="status" />}
                {!mutation.isFetching && <span className="text-dark">Log in</span>}
            </Button>

            <div className="d-flex flex-row justify-content-center align-items-center col-7">
                <div className="col-4"><Divider length={12} /></div>
                <p className="fs-6 text-white-50 user-select-none mx-4 my-auto">or</p>
                <div className="col-4"><Divider length={12} /></div>
            </div>

            <div className="d-flex flex-column justify-content-center align-items-center">
                <p className="fs-6 text-white-50 user-select-none">Log in with:</p>
                <OauthIcons />
            </div>

            <div className="col-12 d-flex flex-column justify-content-center align-items-center gap-2">
                <Divider length={10} />
                <Link className="link-light" to={'/signup'}>
                    Don't have an account? Sign up!
                </Link>
            </div>

            {/* <p className="text-danger">
                {mutation.isError && mutation.error.response?.data}
            </p> */}

        </CenteredForm>
    )
}

export default Login;